import React, { Component } from 'react';


import intl from 'react-intl-universal';
import Select from 'react-select';
import './config'
import Api from '../../api/wxapi'
import { inject, observer } from 'mobx-react';

require('../person/PersonRegist.css')


const url = 'https://customer.test.taihapo.com.cn/'
//个人中心
@inject('store')
@observer
export default class PersonCenter extends Component {
  constructor(props) {
    super();
    this.state = {
      storename: '',
      username: '',
      openid: '',
      isRegist: false,//是否认证
      headurl: '',

    };
  }


  componentDidMount() {
    document.title = '个人中心'
    this.wxrz()
  }
  render() {
    let {
      storename,
      username,
      openid,
      isRegist,
      headurl
    } = this.state

    return (
      <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1, paddingTop: 12, backgroundColor: '#fff', paddingBottom: 12 }}>

        <div className='flex-row-container' style={{ alignItems: 'center', marginTop: 15, marginLeft: 15, marginRight: 15, justifyContent: 'space-around' }}>
          <img
            src={headurl}
            alt=""
            style={{ width: 60, height: 60, objectFit: "contain" }}
          />
          <div className='flex-row-container' style={{ justifyContent: "space-between", flex: 1, alignItems: 'center' }} >
            <div style={{ marginLeft: 15 }}>
              <p>{username}</p>
              <p className='zdhh' style={{ width: 120, fontSize: 10 }} >{openid}</p>
            </div>


            <button onClick={this.gotoRegist} className={isRegist ? 'pc-buttonUnclick' : 'pc-button'}>{isRegist ? '已认证' : '技师认证'}</button>
          </div>
        </div>
        <div className='flex-row-container boxstyle' style={{ alignItems: 'center', justifyContent: "space-around", marginTop: 20, marginLeft: 15, marginRight: 15 }}>
          <div className="flex-column-container" style={{ alignItems: 'center' }} onClick={this.gotoMessage} >
            <img src={require('../../assets/xiaoxi.png')}></img>
            <p style={{ marginTop: 10 }}>消息</p>
          </div>
          <div style={{ height: 80, backgroundColor: '#F4F4F4', width: 2 }}></div>

          <div className="flex-column-container" style={{ alignItems: 'center' }} onClick={this.gotoReward} >
            <img src={require('../../assets/jiangli.png')}></img>
            <p style={{ marginTop: 10 }}>奖励</p>
          </div>
        </div>

        <div className='flex-row-container' style={{ marginTop: 60, alignItems: 'center', justifyContent: "space-between" }} onClick={this.gotoDeveci}>
          <div className='flex-row-container' style={{ alignItems: 'center' }}>
            <img src={require('../../assets/shebei.png')}></img>
            <p style={{ marginLeft: 10 }}>设备信息</p>
          </div>
          <img src={require('../../assets/right.png')}></img>

        </div>

        <div style={{ height: 2, backgroundColor: '#F4F4F4', width: '100%', marginTop: 15 }}></div>

        <div className='flex-row-container' style={{ marginTop: 15, alignItems: "center", justifyContent: "space-between" }} onClick={this.gotoQuestion}>
          <div className='flex-row-container' style={{ alignItems: 'center' }}>
            <img src={require('../../assets/cjwt.png')}></img>
            <p style={{ marginLeft: 10 }}>常见问题</p>
          </div>
          <img src={require('../../assets/right.png')}></img>

        </div>

      </div>
    )
  }

  wxrz() {
    let store = this.props.store
    let code = this.getQueryString('code')
    let wxappid = global.constants.wxappid
    let secret = global.constants.secret
    let redirect_uri1 = url + 'PersonCenter'
    let rurl = encodeURI(redirect_uri1)
    console.log(rurl)
    /*  wxApi.getUser().then(res=>{
        console.log(res)
     }) */

    //先尝试从缓存中获得用户信息
    let userStr = sessionStorage.getItem('user');
    if (userStr && userStr.length > 0) {
      let data = JSON.parse(userStr)
      this.setState({
        username: data.nickname,
        openid: data.openid,
        isRegist: data.is_auth,//是否认证
        headurl: data.headimgurl,
      })
      store.updateUser(data, data.openid)
      sessionStorage.setItem('openid', data.openid)
      if (code) {
        window.location.href = redirect_uri1
      }
      return;
    }

    if (code) {
      Api.getUserInformation({ code: code })
        .then(res => {
          console.log(res)
          if (res.data.code == 0) {
            let data = res.data.data
            sessionStorage.setItem('user', JSON.stringify(data))
            store.updateUser(data, data.openid)
            sessionStorage.setItem('openid', data.openid)
            this.setState({
              username: data.nickname,
              openid: data.openid,
              isRegist: data.is_auth,//是否认证
              headurl: data.headimgurl,
            })

            window.location.href = redirect_uri1
          }

        })
      /* wxApi.getOpenId({appid:wxappid,secret:secret,code:code,grant_type:'authorization_code'}).then(res=>{
          console.log(res)
        }) */

    } else {
      let wxrzurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxappid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      window.location.href = wxrzurl;
    }


  }

  gotoRegist = () => {
    if (this.state.isRegist) {
      return
    }

    this.props.history.push(`/person/PersonRegist`)
  }


  gotoDeveci = () => {
    if (this.state.isRegist) {
      this.props.history.push(`/person/DeviceInfomation`)
    } else {
      this.props.history.push(`/person/PersonRegist?redirect_uri=${url}DeviceInfomation`)
    }


  }

  gotoQuestion = () => {

    this.props.history.push(`/person/QuestionList`)
  }


  gotoMessage = () => {
    if (this.state.isRegist) {
      this.props.history.push(`/person/message/MessageList`)
    } else {
      this.props.history.push(`/person/PersonRegist?redirect_uri=${url}DeviceInfomation`)
    }


  }

  gotoReward = () => {
    if (this.state.isRegist) {
      this.props.history.push(`/person/reward/Reward`)
    } else {
      this.props.history.push(`/person/PersonRegist?redirect_uri=${url}DeviceInfomation`)
    }


  }


  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

}




// WEBPACK FOOTER //
// ./src/views/person/PersonCenter.js